const ITEMS = [
  "TALENT",
  "BRANDS",
  "OPPORTUNITIES",
  "STRATEGY",
  "ACCESS",
  "NEGOTIATION",
  "GLOBAL REACH",
  "WE ARE THE DEAL",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="overflow-hidden border-y border-dealer-ivory/10 py-6"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="dealer-marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span
                  className={`whitespace-nowrap px-8 font-serif text-lg tracking-[0.15em] ${
                    item === "WE ARE THE DEAL"
                      ? "text-dealer-burgundybright"
                      : "text-dealer-ivory/60"
                  }`}
                >
                  {item}
                </span>
                <span className="block h-1 w-1 rounded-full bg-dealer-burgundy" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
